/**
 * Utilitários para conversão de sistemas de coordenadas
 */
import proj4 from 'proj4';

/**
 * Detecta se as coordenadas estão em UTM baseado em seus valores
 * @param {number} x - Coordenada X (possivelmente UTM easting ou longitude)
 * @param {number} y - Coordenada Y (possivelmente UTM northing ou latitude)
 * @returns {boolean} - Verdadeiro se as coordenadas são provavelmente UTM
 */
export function isLikelyUTM(x, y) {
  // UTM easting geralmente está entre 166k e 834k
  // UTM northing geralmente está entre 0 e 10.000k (hemisfério norte)
  // ou entre 0 e 10.000k (hemisfério sul, mas com offset de 10.000k)

  // Se os valores são muito grandes para serem longitude/latitude
  if (Math.abs(x) > 180 || Math.abs(y) > 90) {
    // E parecem estar no range de UTM
    if (x > 160000 && x < 840000 && ((y > 0 && y < 10000000) || (y > 0 && y < 20000000))) {
      return true;
    }
  }

  return false;
}

/**
 * Converte coordenadas UTM para WGS84
 * @param {number} easting - UTM easting
 * @param {number} northing - UTM northing
 * @param {number} zone - UTM zone number (1-60)
 * @param {string} hemisphere - Hemisfério 'N' ou 'S'
 * @returns {Array|null} - Array [longitude, latitude] em WGS84 ou null se falhar
 */
export function convertUTMtoWGS84(easting, northing, zone = 22, hemisphere = 'S') {
  try {
    // Define sistemas de coordenadas
    const wgs84 = '+proj=longlat +datum=WGS84 +no_defs';
    const utm = `+proj=utm +zone=${zone} +${hemisphere === 'S' ? 'south' : ''} +datum=WGS84 +units=m +no_defs`;

    // Configura a conversão
    const conversion = proj4(utm, wgs84);

    // Executa a conversão
    const [lon, lat] = conversion.forward([easting, northing]);

    return [lon, lat];
  } catch (error) {
    console.error('[GeometryService] Erro ao converter UTM para WGS84:', error);
    return null;
  }
}
